import OutputBuffer from "./OutputBuffer";

export default class TerminalValidator {
    constructor(terminalBus, expectedOutput) {
        this.terminalBus = terminalBus
        this.expectedOutput = expectedOutput
        this.outputBuffer = new OutputBuffer(terminalBus, output => {
            this.isValid = this.validate(output);
        })
    }

    validate (output) {
        return output === this.expectedOutput;
    }

    writeSuccess () {
        this.terminalBus.$emit(
            'writeMessage',
            '\x1B[1;3;32mGratulacje, zadanie zostało wykonane poprawnie!\x1B[0m\n'
        )
    }

    writeFailure () {
        this.terminalBus.$emit(
            'writeMessage',
            '\x1B[1;3;31mMusisz coś jeszcze poprawić\x1B[0m\n'
        )
    }
}
